import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "saveBox" }
const _hoisted_2 = { class: "saveBoxInner" }
const _hoisted_3 = { class: "saveTitle" }
const _hoisted_4 = { class: "savePrompt" }
const _hoisted_5 = { class: "rowMain" }
const _hoisted_6 = { class: "rowMainInput" }
const _hoisted_7 = { class: "saveBtn" }
const _hoisted_8 = { class: "btnBox" }

import {
    Close,
} from "@element-plus/icons-vue";
import { ref, onMounted } from 'vue'
import { languageList,styleList} from "./icon.ts"
// 引入接口
import newCaptionApi from "@/api/newCaption/index.ts";

export default /*@__PURE__*/_defineComponent({
  __name: 'savePage',
  props: {
    id:String
},
  emits: ['closeThis','recognition','reVersionList'],
  setup(__props, { emit: __emit }) {

const props = __props
const showFrom=ref(false)
const Txt=ref()
onMounted(()=>{
    console.log(props.languagefrom)
   
    if(props.languagefrom==undefined||props.languagefrom==''){
        showFrom.value=true
    }
})
const emit = __emit
// 关闭弹窗
const closeBox=()=>{
    emit('closeThis')
}
const onOff=ref(false)
const handleClose = () => {
    console.log(props.id)
    if(onOff.value){
        return
    }
    onOff.value=true
    newCaptionApi.release( false, props.id,'',Txt.value).then((res)=>{
        console.log(res)
        if(res.code==200){
            console.log('发布成功')
            emit('closeThis')
            emit('reVersionList')
        }
    })
    // console.log(tolanguage.value)
    // emit('recognition',[tolanguage.value,fromlanguage.value])
}


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("span", null, "保存", -1)),
        _createElementVNode("span", {
          class: "closeBtn",
          onClick: _withModifiers(closeBox, ["stop"])
        }, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Close))
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "rowMainTitle" }, "版本名称", -1)),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "请输入版本名称",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((Txt).value = $event))
            }, null, 512), [
              [_vModelText, Txt.value]
            ])
          ])
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "twxtInfo" }, [
          _createElementVNode("span", null, "注意 ："),
          _createElementVNode("span", null, "保存成功后将会切换到最新版本 "),
          _createElementVNode("span", null, "如需修改历史版本请右上角切换版本")
        ], -1)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", {
              class: "btnNo",
              onClick: _withModifiers(closeBox, ["stop"])
            }, "取消"),
            _createElementVNode("span", {
              class: "btnOk",
              onClick: _withModifiers(handleClose, ["stop"])
            }, "确定")
          ])
        ])
      ])
    ])
  ]))
}
}

})